import {
  SwitchTenantPayload,
  SwitchTenantSuccessResponse,
  SwitchTenantErrorResponse,
  switchTenantApi,
} from 'TenantModule/api/switchTenantApi';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useNotification } from 'hooks/useNotification';
import { extractApiErrorMessage } from 'utils/extractApiErrorMessage';

export const useSwitchTenantMutation = () => {
  const token = useSelector(selectAuthToken);
  const { showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<SwitchTenantSuccessResponse>,
    AxiosResponse<SwitchTenantErrorResponse>,
    SwitchTenantPayload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return switchTenantApi({ params, token });
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Switch tenant failed! ${extractApiErrorMessage(error)}`);
    },
  });
  return {
    switchTenant: mutation.mutate,
    isSwitchingTenant: mutation.isPending,
  };
};
